import React, { Component } from 'react';

import { Svgs } from './Svgs';

class Header extends Component {

  constructor(props) {
    super(props);

    this.startAgain = this.startAgain.bind(this);
  }

  startAgain = (e) => {
    window.historys.push('/');
  }

  render() {
    return (
      <header className="app-header">
       <button type="button" onClick={(e) => this.startAgain(e)}><Svgs width="60" height="60" svg="ApLogo" class="app-header__logo" /></button>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js